import React from 'react'
import MobileNonDigitalProductsListing from './MobileNonDigitalProductsListing'
import MobileBottomNavbar from '../../../MobGlobalComponents/MobileBottomNavbar/MobileBottomNavbar'
import MobileNavbarInside from '../../../MobGlobalComponents/MobileNavbar/MobileNavbarInside'

const MobileNonDigitalProductList = ({ user }) => {
	return (
		<div>
			<MobileNavbarInside user={user} />
			<MobileNonDigitalProductsListing user={user} />
			<MobileBottomNavbar user={user} />
		</div>
	)
}

export default MobileNonDigitalProductList
